/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LiftVehicleSuspensionRequestDto,
  SuspensionAffectedBookingDto,
  VehicleSuspensionDto,
  VehicleSuspensionRequestDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Every vehicle out of circulation: one active suspension per suspended vehicle, comments included, longest-running first, so nothing suspended is forgotten. Not paged: few vehicles are suspended at once. Not cached. BattSupport or BattAdmin.
 * @summary getSuspendedVehicles
 */
export const getSuspendedVehicles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleSuspensionDto[]>(
      {url: `/fleet/vehicle/v1/suspended-vehicles`, method: 'GET', signal
    },
      );
    }
  

export const getGetSuspendedVehiclesQueryKey = () => {
    return [`/fleet/vehicle/v1/suspended-vehicles`] as const;
    }

    
export const getGetSuspendedVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof getSuspendedVehicles>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuspendedVehiclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuspendedVehicles>>> = ({ signal }) => getSuspendedVehicles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuspendedVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof getSuspendedVehicles>>>
export type GetSuspendedVehiclesQueryError = ErrorType<null | null | null>


export function useGetSuspendedVehicles<TData = Awaited<ReturnType<typeof getSuspendedVehicles>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspendedVehicles>>,
          TError,
          Awaited<ReturnType<typeof getSuspendedVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspendedVehicles<TData = Awaited<ReturnType<typeof getSuspendedVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspendedVehicles>>,
          TError,
          Awaited<ReturnType<typeof getSuspendedVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspendedVehicles<TData = Awaited<ReturnType<typeof getSuspendedVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getSuspendedVehicles
 */

export function useGetSuspendedVehicles<TData = Awaited<ReturnType<typeof getSuspendedVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspendedVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuspendedVehiclesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The vehicle's active suspension, comments included. 204 when the vehicle carries none. Not cached: a change is visible on the next call. BattSupport or BattAdmin.
 * @summary getActiveVehicleSuspension
 */
export const getActiveVehicleSuspension = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleSuspensionDto | null>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspension`, method: 'GET', signal
    },
      );
    }
  

export const getGetActiveVehicleSuspensionQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/suspension`] as const;
    }

    
export const getGetActiveVehicleSuspensionQueryOptions = <TData = Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveVehicleSuspensionQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveVehicleSuspension>>> = ({ signal }) => getActiveVehicleSuspension(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActiveVehicleSuspensionQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveVehicleSuspension>>>
export type GetActiveVehicleSuspensionQueryError = ErrorType<null | null | null | null>


export function useGetActiveVehicleSuspension<TData = Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveVehicleSuspension>>,
          TError,
          Awaited<ReturnType<typeof getActiveVehicleSuspension>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveVehicleSuspension<TData = Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveVehicleSuspension>>,
          TError,
          Awaited<ReturnType<typeof getActiveVehicleSuspension>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActiveVehicleSuspension<TData = Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getActiveVehicleSuspension
 */

export function useGetActiveVehicleSuspension<TData = Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveVehicleSuspension>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActiveVehicleSuspensionQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Replaces the kind, reason and comment of the active suspension. Sending what it already holds changes nothing and records nothing. Tightening restricted → full and changing the reason or comment: BattSupport or BattAdmin. Loosening full → restricted is a partial lift: BattAdmin only.
 * @summary changeVehicleSuspension
 */
export const changeVehicleSuspension = (
    vehicleId: string,
    vehicleSuspensionRequestDto: BodyType<VehicleSuspensionRequestDto>,
 ) => {
      
      
      return customInstance<VehicleSuspensionDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspension`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleSuspensionRequestDto
    },
      );
    }
  


export const getChangeVehicleSuspensionMutationOptions = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof changeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext> => {

const mutationKey = ['changeVehicleSuspension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeVehicleSuspension>>, {vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  changeVehicleSuspension(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeVehicleSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof changeVehicleSuspension>>>
    export type ChangeVehicleSuspensionMutationBody = BodyType<VehicleSuspensionRequestDto>
    export type ChangeVehicleSuspensionMutationError = ErrorType<null | null | null | null | null | null>

    /**
 * @summary changeVehicleSuspension
 */
export const useChangeVehicleSuspension = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeVehicleSuspension>>,
        TError,
        {vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>},
        TContext
      > => {

      const mutationOptions = getChangeVehicleSuspensionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Takes the vehicle out of circulation until a BattAdmin lifts it. Always succeeds on a vehicle that carries no active suspension, also with bookings planned or a trip running, and never cancels a booking or notifies anyone. Recorded in the vehicle's Activity log, without the comment. BattSupport or BattAdmin.
 * @summary placeVehicleSuspension
 */
export const placeVehicleSuspension = (
    vehicleId: string,
    vehicleSuspensionRequestDto: BodyType<VehicleSuspensionRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleSuspensionDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspension`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleSuspensionRequestDto, signal
    },
      );
    }
  


export const getPlaceVehicleSuspensionMutationOptions = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof placeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext> => {

const mutationKey = ['placeVehicleSuspension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof placeVehicleSuspension>>, {vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  placeVehicleSuspension(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlaceVehicleSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof placeVehicleSuspension>>>
    export type PlaceVehicleSuspensionMutationBody = BodyType<VehicleSuspensionRequestDto>
    export type PlaceVehicleSuspensionMutationError = ErrorType<null | null | null | null | null | null>

    /**
 * @summary placeVehicleSuspension
 */
export const usePlaceVehicleSuspension = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof placeVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof placeVehicleSuspension>>,
        TError,
        {vehicleId: string;data: BodyType<VehicleSuspensionRequestDto>},
        TContext
      > => {

      const mutationOptions = getPlaceVehicleSuspensionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * The bookings the vehicle's active suspension leaves stranded, earliest first: awaiting approval or approved and not yet ended, or running, whose booker may not use the vehicle under the suspension. Under a restricted suspension the bookings of the vehicle's own people are not listed. A BattAdmin's own bookings are listed too, although that BattAdmin may still start them on the fleet surface. Computed on every call and never stored, so a booking cancelled or rebooked with the existing tools drops off at once. BattSupport or BattAdmin.
 * @summary getSuspensionAffectedBookings
 */
export const getSuspensionAffectedBookings = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SuspensionAffectedBookingDto[]>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspension/affected-bookings`, method: 'GET', signal
    },
      );
    }
  

export const getGetSuspensionAffectedBookingsQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/suspension/affected-bookings`] as const;
    }

    
export const getGetSuspensionAffectedBookingsQueryOptions = <TData = Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuspensionAffectedBookingsQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>> = ({ signal }) => getSuspensionAffectedBookings(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuspensionAffectedBookingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>>
export type GetSuspensionAffectedBookingsQueryError = ErrorType<null | null | null | null>


export function useGetSuspensionAffectedBookings<TData = Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionAffectedBookings>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionAffectedBookings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionAffectedBookings<TData = Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuspensionAffectedBookings>>,
          TError,
          Awaited<ReturnType<typeof getSuspensionAffectedBookings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspensionAffectedBookings<TData = Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getSuspensionAffectedBookings
 */

export function useGetSuspensionAffectedBookings<TData = Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuspensionAffectedBookings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuspensionAffectedBookingsQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Puts the vehicle back into circulation and records who lifted it, when and why. The suspension stays in the vehicle's history. BattAdmin only.
 * @summary liftVehicleSuspension
 */
export const liftVehicleSuspension = (
    vehicleId: string,
    liftVehicleSuspensionRequestDto: BodyType<LiftVehicleSuspensionRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleSuspensionDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspension/lift`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: liftVehicleSuspensionRequestDto, signal
    },
      );
    }
  


export const getLiftVehicleSuspensionMutationOptions = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liftVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<LiftVehicleSuspensionRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof liftVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<LiftVehicleSuspensionRequestDto>}, TContext> => {

const mutationKey = ['liftVehicleSuspension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof liftVehicleSuspension>>, {vehicleId: string;data: BodyType<LiftVehicleSuspensionRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  liftVehicleSuspension(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LiftVehicleSuspensionMutationResult = NonNullable<Awaited<ReturnType<typeof liftVehicleSuspension>>>
    export type LiftVehicleSuspensionMutationBody = BodyType<LiftVehicleSuspensionRequestDto>
    export type LiftVehicleSuspensionMutationError = ErrorType<null | null | null | null | null | null>

    /**
 * @summary liftVehicleSuspension
 */
export const useLiftVehicleSuspension = <TError = ErrorType<null | null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof liftVehicleSuspension>>, TError,{vehicleId: string;data: BodyType<LiftVehicleSuspensionRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof liftVehicleSuspension>>,
        TError,
        {vehicleId: string;data: BodyType<LiftVehicleSuspensionRequestDto>},
        TContext
      > => {

      const mutationOptions = getLiftVehicleSuspensionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Every suspension the vehicle ever carried, the active one included, newest first, with who placed, changed and lifted each, when and why. Not paged: a vehicle carries few. BattSupport or BattAdmin.
 * @summary getVehicleSuspensionHistory
 */
export const getVehicleSuspensionHistory = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleSuspensionDto[]>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/suspensions`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleSuspensionHistoryQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}/suspensions`] as const;
    }

    
export const getGetVehicleSuspensionHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleSuspensionHistoryQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>> = ({ signal }) => getVehicleSuspensionHistory(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleSuspensionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>>
export type GetVehicleSuspensionHistoryQueryError = ErrorType<null | null | null | null>


export function useGetVehicleSuspensionHistory<TData = Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleSuspensionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVehicleSuspensionHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleSuspensionHistory<TData = Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleSuspensionHistory>>,
          TError,
          Awaited<ReturnType<typeof getVehicleSuspensionHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleSuspensionHistory<TData = Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getVehicleSuspensionHistory
 */

export function useGetVehicleSuspensionHistory<TData = Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleSuspensionHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleSuspensionHistoryQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



